// src/app/EcransAccueil.jsx — l'écran d'attente et la page de connexion.
// Déplacés à l'identique depuis src/App.jsx (P-3.5, squelette).

import { DS } from '../lib/ui'
import { LOGO_B64 } from '../assets/logo'

export function ecranChargement() {
  return (
    <div style={{display:"flex",alignItems:"center",justifyContent:"center",height:"100vh",background:DS.bg,flexDirection:"column",gap:16}}>
      <img src={`data:image/png;base64,${LOGO_B64}`} alt="logo" style={{width:60,height:60,borderRadius:"50%",objectFit:"cover",boxShadow:"0 4px 16px rgba(33,83,135,.3)"}} />
      <div style={{color:DS.navy,fontSize:15,fontWeight:700,fontFamily:DS.fontDisplay}}>Chargement...</div>
    </div>
  )
}

export function ecranConnexion({ loginForm, setLoginForm, loginLoading, handleLogin }) {
  return (
    <div style={{display:"flex",alignItems:"center",justifyContent:"center",minHeight:"100vh",background:`linear-gradient(135deg,${DS.navyDark} 0%,${DS.navy} 60%,${DS.navyLight} 100%)`,fontFamily:DS.fontBody}}>
      <div style={{background:"#fff",borderRadius:20,padding:32,width:"100%",maxWidth:360,boxShadow:"0 20px 60px rgba(0,0,0,.25)"}}>
        <div style={{textAlign:"center",marginBottom:28}}>
          <img src={`data:image/png;base64,${LOGO_B64}`} alt="logo" style={{width:56,height:56,borderRadius:"50%",objectFit:"cover",marginBottom:12,boxShadow:"0 4px 12px rgba(33,83,135,.2)"}}/>
          <div style={{fontFamily:DS.fontDisplay,fontSize:22,fontWeight:700,color:DS.navy}}>FULLBNBZEN</div>
          <div style={{fontSize:12,color:"#aaa",marginTop:4}}>Connexion</div>
        </div>
        <div style={{marginBottom:12}}>
          <div style={{fontSize:11,color:"#888",marginBottom:4,fontWeight:600,textTransform:"uppercase",letterSpacing:.5}}>Email</div>
          <input type="email" autoComplete="email" value={loginForm.email} onChange={e=>setLoginForm(f=>({...f,email:e.target.value,error:""}))}
            onKeyDown={e=>e.key==="Enter"&&handleLogin()}
            placeholder="email@exemple.com"
            style={{width:"100%",border:"1px solid #dde3ec",borderRadius:10,padding:"11px 14px",fontSize:13,outline:"none",fontFamily:DS.fontBody}}/>
        </div>
        <div style={{marginBottom:8}}>
          <div style={{fontSize:11,color:"#888",marginBottom:4,fontWeight:600,textTransform:"uppercase",letterSpacing:.5}}>Mot de passe</div>
          <input type="password" value={loginForm.password} onChange={e=>setLoginForm(f=>({...f,password:e.target.value,error:""}))}
            onKeyDown={e=>e.key==="Enter"&&handleLogin()}
            placeholder="••••••"
            style={{width:"100%",border:"1px solid #dde3ec",borderRadius:10,padding:"11px 14px",fontSize:13,outline:"none",fontFamily:DS.fontBody}}/>
        </div>
        {loginForm.error&&<div style={{color:DS.red,fontSize:12,marginBottom:8,fontWeight:600}}>{loginForm.error}</div>}
        <button onClick={handleLogin} disabled={loginLoading}
          style={{width:"100%",padding:13,background:DS.navy,color:"#fff",border:"none",borderRadius:10,fontWeight:700,fontSize:14,cursor:"pointer",fontFamily:DS.fontBody,marginTop:8}}>
          {loginLoading?"Connexion...":"Se connecter"}
        </button>
      </div>
    </div>
  )
}
